export let AuthConfig: any = {
    headers: {
        StaticToken: '@8c191d9b-b139-4e45-8b85-8c0ca07cdd05!',
    }
};

export let AuthConfig2: any = {
    headers: {
        'Access-Key': 'sAcheLr8aIvFyd0taqvOgReAzN9Be1d1y0s',
    }
};